// src/documents/claimDocuments.js
//
// LOR y SPOL del reclamo: qué datos llevan (lorData/spolData), qué les falta
// y cómo se genera el PDF sobre la plantilla. Lo usan el panel Documentos y
// el paso de firma de cada documento (DocumentSignature), para poder
// generarlo ahí mismo sin ir a otra sección.
import lorTemplateUrl from '../assets/documents/lor-template.pdf';
import spolTemplateUrl from '../assets/documents/spol-template.pdf';
import { fillPdf } from './pdfFill';
import { LOR_TEMPLATE } from './lorTemplate';
import { SPOL_TEMPLATE } from './spolTemplate';
import { buildLorData } from './lorData';
import { buildSpolData } from './spolData';

const safeName = value => String(value || '').replace(/[\\/:*?"<>|]+/g, '').trim();

// docType 'lor' | 'spol'. `estimate` = stepData del paso "RS / POL" (montos de la SPOL).
export const buildClaimDocument = (docType, claimRecord, language = 'es', estimate = {}) => (docType === 'spol'
  ? { id: 'SPOL', title: 'Sworn Statement in Proof of Loss', templateUrl: spolTemplateUrl, template: SPOL_TEMPLATE, ...buildSpolData(claimRecord || {}, estimate, language) }
  : { id: 'LOR', title: 'Letter of Representation (DFS + Rights + Contract)', templateUrl: lorTemplateUrl, template: LOR_TEMPLATE, ...buildLorData(claimRecord || {}, language) });

export const renderClaimDocument = async document => {
  const templateBytes = new Uint8Array(await (await fetch(document.templateUrl)).arrayBuffer());
  return fillPdf(templateBytes, document.template, document.values);
};

export const claimDocumentFileName = (document, claimRecord) =>
  `${[document.id, safeName(claimRecord.clientName), safeName(claimRecord.claimNumber)].filter(Boolean).join(' - ')}.pdf`;
